import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { addToCartFB, removeFromCartFB } from "libs/firebase";
import _ from "lodash";
import { CartProps } from "src/common/types/cart";
import { PopularItemResponse } from "src/common/types/response/storeItems";

const initialState: CartProps = {
  data: null,
};

function addToCart(item: PopularItemResponse, state: CartProps) {
  const storeData = { ...state.data };
  const storeId = item.store._id;
  if (!storeData[storeId]) {
    storeData[storeId] = {
      name: item.store.name,
      items: [{ ...item, quantity: 1 }],
    };
    addToCartFB({ ...item, quantity: 1 });
  } else {
    const existingItem = storeData[storeId].items.find(
      (it) => it._id === item._id
    );
    if (existingItem) {
      existingItem.quantity += 1;
      addToCartFB({ ...item, quantity: existingItem.quantity });
    } else {
      storeData[storeId].items.push({ ...item, quantity: 1 });
      addToCartFB({ ...item, quantity: 1 });
    }
  }
  return storeData;
}

function removeFromCart(item: PopularItemResponse, state: CartProps) {
  const storeData = { ...state.data };
  const storeId = item.store._id;
  const items = storeData[storeId]?.items;

  if (items) {
    const newItems = items.filter((it) => {
      if (it._id === item._id && item.quantity === 1) {
        removeFromCartFB({ ...it, quantity: 0 });
        return false;
      } else if (it._id === item._id && item.quantity > 1) {
        it.quantity -= 1;
        removeFromCartFB({ ...it });
      }
      return true;
    });

    if (newItems.length === 0) {
      delete storeData[storeId];
    } else {
      storeData[storeId].items = newItems;
    }
  }

  return storeData;
}

export const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addItem: (state, action: PayloadAction<PopularItemResponse>) => {
      state.data = addToCart(action.payload, state);
    },
    removeItem: (state, action: PayloadAction<PopularItemResponse>) => {
      state.data = removeFromCart(action.payload, state);
    },
    removeStore: (state, action: PayloadAction<string>) => {
      delete state.data[action.payload];
    },
    emptyCart: () => initialState,
    clearData: () => initialState,
  },
  extraReducers: (builder) => {},
});

export const { addItem, removeItem, emptyCart, clearData, removeStore } =
  cartSlice.actions;
export { addToCart, removeFromCart };
export default cartSlice.reducer;
